// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-call-view{height:100%;width:100%;position:absolute;display:flex;flex-direction:column;align-content:center;justify-content:center;color:var(--color-text-maxcontrast);text-align:center}.empty-call-view .icon{background-size:64px;height:64px;width:64px;margin:0 auto 15px}.empty-call-view button{margin:4px auto;z-index:1}\n", ""]);
// Exports
module.exports = exports;
